export { ChainId, isKnownChainId } from '@sirius-cybernetics-42/product-config'
export type { ChainIdValue } from '@sirius-cybernetics-42/product-config'
import type { ChainIdValue } from '@sirius-cybernetics-42/product-config'

/** Numeric chain id used across the SDK and app config. */
export type ChainId = ChainIdValue

/** Coerce wagmi/viem numeric chain id to app ChainId. */
export function asChainId(chainId: number): ChainId {
  return chainId as ChainId
}
